import { render } from "./allMeals.vue?vue&type=template&id=125d32a2&scoped=true"
import script from "./allMeals.vue?vue&type=script&lang=js"
export * from "./allMeals.vue?vue&type=script&lang=js"

import "./allMeals.vue?vue&type=style&index=0&id=125d32a2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-125d32a2"]])

export default __exports__